import React, { useState, useEffect } from "react";
import t from "../../../../helpers/t";

import { useSelector, userActions, taskActions } from "inbooma-api"; // necessary to communicate with inbooma-react api
import { Biscuit } from "../../../../../utils"; // necessary to communicate with inbooma-react
import { $, moment, CountryList, _ } from "../../../../../../vendor";
import { generateClientHash } from "../../../../../utils/Uri";
import { getApiHost, getEnv } from "../../../../../Sync";
import UserInput from "../UserInput";
import { getDocHandler, getUserString, in_array } from "../../../../../utils/Helper";
import MembershipsSelect from "./ViewItems/MembershipsSelect";
import LocationsSelect from "./ViewItems/LocationsSelect";
import AbonnementsSelect from "./ViewItems/AbonnementsSelect";
import { rbac } from "../../index";

const ItemView = (props) => {
  // initialize user - set selected user or set defaults
  const [user, setUser] = useState(
    props.user === null
      ? {
          client_id: Number(Biscuit.get("user.client_id")),
          active: true,
          company: "",
          customer_nbr: "",
          email: null,
          first_name: "",
          last_name: "",
          id_card_nbr: "",
          birthdate: "",
          lang: Biscuit.get("user.lang"),
          newsletter: false,
          role: props.requestPath === "/users/staff" ? "manager" : "user",
          title: "",
          employee_number: null,
          username: null,
          memberships: [],
          abonnements_users: [],
          user_addresses: [
            {
              country: Biscuit.get("client.country"),
            },
          ],
          user_locations: [],
          id: null,
          free_unit_able: false,
          deleted: null,
        }
      : props.user,
  );
  console.log(user, "user");
  const [itemState, setItemState] = useState("init"); // init, pending_tasks, pending_created, pending_modified, ready, saving
  const [matrixFields, setMatrixFields] = useState([]);
  const _addUser = useSelector((state) => state.users_data.register);
  const _restoreUser = useSelector((state) => state.users_data.restoreDeletedUser);
  const _purgeUser = useSelector((state) => state.users_data.purgeUser);
  const _editUser = useSelector((state) => state.users_data.editUser);
  const _tasks = useSelector((state) => state.tasks.tasks);
  const [tasksPending, setTasksPending] = useState(false);
  const [formError, setFormError] = useState({}); // object of error items such as 'email'
  const [saveUserPending, setSaveUserPending] = useState(false);

  const [createdBy, setCreatedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
  });
  const [modifiedBy, setModifiedBy] = useState({
    id: null,
    first_name: "",
    last_name: "",
  });

  let language = Biscuit.get("user.lang");
  const lang = Biscuit.get("user.lang").split("_");

  useEffect(() => {
    if (_tasks.success === "" || !tasksPending) return;
    if (_tasks.success === true) {
      if (typeof user.created_by !== "undefined" && user.created_by != null) {
        setItemState("pending_created");
        props.dispatch(
          userActions.getUser({
            token: Biscuit.get("token"),
            id: user.created_by,
            parameters: {
              headers: {
                "Accept-Language": language,
              },
            },
          }),
        );
      } else if (typeof user.modified_by !== "undefined" && user.modified_by != null) {
        setItemState("pending_modified");
        props.dispatch(
          userActions.getUser({
            token: Biscuit.get("token"),
            id: user.modified_by,
            parameters: {
              headers: {
                "Accept-Language": language,
              },
            },
          }),
        );
      } else {
        setItemState("ready"); // no user to request
      }
    }
    setTasksPending(false);
  }, [_tasks]);

  let _countryList = {};
  _countryList[""] = "";
  _.each(CountryList.getNames(lang[0]), (key, val) => {
    _countryList[val] = key;
  });

  const hasPrivacyAccepted =
    user.privacy_accepted !== undefined &&
    user.privacy_accepted !== null &&
    user.privacy_accepted !== "";
  const hasTosAccepted =
    user.tos_date !== undefined && user.tos_date !== null && user.tos_date !== "";

  const getUserAddressInfo = (key) => {
    if (
      user.user_addresses !== undefined &&
      user.user_addresses[0] !== undefined &&
      user.user_addresses[0][key] !== undefined
    ) {
      return user.user_addresses[0][key];
    }
    return "";
  };

  const getUserMembershipInfo = (key) => {
    if (
      typeof user.memberships !== undefined &&
      user.memberships[0] !== undefined &&
      user.memberships[0][key] !== undefined
    ) {
      return user.memberships[0][key];
    }
    return "";
  };

  if (itemState === "init") {
    // get tasks

    setItemState("pending_tasks");
    if (user.role === "user") {
      props.dispatch(
        taskActions.getTasks({
          filter: {
            includes: "Users",
            fk_model: "Users",
            fk_id: user.id,
          },
          token: Biscuit.get("token"),
        }),
      );
    } else {
      props.dispatch(
        taskActions.getTasks({
          filter: {
            includes: "Users",
            assignee: user.id,
          },
          token: Biscuit.get("token"),
        }),
      );
    }

    /* let newM = [];
         _.each(props.matrixFields, function(val){
             newM[val.name] = val;
             newM.length++;
         });*/
    setMatrixFields(props.matrixFields);
  }

  /*    useEffect(() => {

        if (_users.success === "") {
            return;
        }

        if (itemState !== 'saving') return;

        if (props.status.action === 'add') {

            if (_users.users.success === true) {
                props.showNotification('success', _users.data[_users.data.length - 1].id);
            }

            if (_users.success === false) {
                props.showNotification('warning', 0);
            }
        } else {

            if (_users.success === true) {
                props.showNotification('success', props.user.id);
            }

            if (_users.success === false) {
                props.showNotification('warning', props.user.id);
            }
        }

        // close window
        abortButtonRef.current.click();
    }, [_users]);*/

  useEffect(() => {
    if (_editUser.success === "" || !saveUserPending) return;
    console.log("in edit user");
    if (_editUser.success === true) {
      props.showNotification("success", _editUser.data.id, null, "user");
      // close window
      abortButtonRef.current.click();
    } else {
      let message = "";
      if (_editUser.data.errors) {
        let formErrorClone = { ...formError };
        Object.keys(_editUser.data.errors).forEach((key) => {
          const errorObj = _editUser.data.errors[key];
          Object.keys(errorObj).forEach((innerKey) => {
            const errorMessage = errorObj[innerKey];
            message += `${key}: ${errorMessage}\n`;
            formErrorClone[key] = errorMessage;
            setFormError(formErrorClone);
            /* console.log(innerKey); */
          });
        });
      } else {
        message = _editUser.data.message;
      }
      setItemState("ready");
      props.showNotification("warning", props.user.id, message, "user");
    }
    // if (itemState !== 'saving') return;

    setSaveUserPending(false);
  }, [_editUser]);

  useEffect(() => {
    if (_restoreUser.success === "" || !saveUserPending) return;

    if (_restoreUser.success === true) {
      setUser(_restoreUser.data);
    } else {
      let message = "";
      if (_restoreUser.data.errors) {
        let formErrorClone = { ...formError };
        Object.keys(_restoreUser.data.errors).forEach((key) => {
          const errorObj = _restoreUser.data.errors[key];
          Object.keys(errorObj).forEach((innerKey) => {
            const errorMessage = errorObj[innerKey];
            message += `${key}: ${errorMessage}\n`;
            formErrorClone[key] = errorMessage;
            setFormError(formErrorClone);
            /* console.log(innerKey); */
          });
        });
      } else {
        message = _restoreUser.data.message;
      }
      props.showNotification("warning", props.user.id, message, "user");
    }
    // if (itemState !== 'saving') return;

    setSaveUserPending(false);
  }, [_restoreUser]);

  useEffect(() => {
    if (_purgeUser.success === "" || !saveUserPending) return;

    if (_purgeUser.success === true) {
      props.showNotification("success", getUserString(user), "purged", "user");
    } else {
      props.showNotification("warning", props.user.id, _purgeUser.data.message, "user");
    }
    // if (itemState !== 'saving') return;

    setSaveUserPending(false);
    abortButtonRef.current.click();
  }, [_purgeUser]);

  useEffect(() => {
    if (_addUser.success === "" || !saveUserPending) return;
    console.log("in add user");
    if (_addUser.success === true) {
      props.showNotification("success", _addUser.data.id, "saved", "user");
      // close window
      abortButtonRef.current.click();
    } else {
      let message = "";
      if (_addUser.data.errors) {
        let formErrorClone = { ...formError };
        Object.keys(_addUser.data.errors).forEach((key) => {
          const errorObj = _addUser.data.errors[key];
          Object.keys(errorObj).forEach((innerKey) => {
            const errorMessage = errorObj[innerKey];
            message += `${key}: ${errorMessage}\n`;
            formErrorClone[key] = errorMessage;
            setFormError(formErrorClone);
            /* console.log(innerKey); */
          });
        });
      } else {
        message = _addUser.data.message;
      }
      setItemState("ready");
      props.showNotification(
        "warning",
        typeof props.user?.id !== "undefined" ? props.user.id : null,
        message,
        "user",
      ); //user ist null, kp wieso
    }
    // if (itemState !== 'saving') return;

    setSaveUserPending(false);
  }, [_addUser]);

  /* useEffect(() => {

        if (_userRegister.success === "") {
            return;
        }

        if (itemState !== 'saving') return;

        if (_userRegister.success === true) {
            props.showNotification('success', _userRegister.data.id);
            abortButtonRef.current.click();
        } else if (_userRegister.success === false) {
            let formErrorClone = { ...formError };
            const errors = _userRegister.data.errors;
            if (typeof errors.email !== 'undefined' && typeof errors.email._isUnique !== 'undefined') {
                props.showNotification('warning', null, 'saved', t('user_error_unique_mail'));
                // mark field red
                formErrorClone.email = "isUnique";
            }
            if (typeof errors.username !== 'undefined' && typeof errors.username._isUnique !== 'undefined') {
                props.showNotification('warning', null, 'saved', t('user_error_unique_username'));
                // mark field red
                formErrorClone.username = "isUnique";
            }
            // stop rolling of submit button
            setFormError(formErrorClone);
            setItemState('ready');
        }
    }, [_userRegister]); */

  // evaluate form and send user to api
  const onSubmit = () => {
    let usercopy = {};
    Object.assign(usercopy, user);
    let errmsg = "";
    let matrixF = Object.assign({}, matrixFields);
    _.each(matrixF, function (val, index) {
      if (
        val.required_be &&
        (typeof usercopy[index] === "undefined" ||
          usercopy[index] === "" ||
          usercopy[index] === null)
      ) {
        $("#user_item_input_" + index).css("border-color", "red");
        if (errmsg === "") {
          errmsg = val.display_name;
        } else {
          errmsg += ", " + val.display_name;
        }
      }
    });
    if (errmsg !== "") {
      props.showNotification("warning", props.user.id, "saving", errmsg + " " + t("are required"));
      return;
    }

    if (user.email === "" || user.email === null) {
      delete usercopy.email;
    } else {
      usercopy.email = user.email.trim();
    }

    usercopy.first_name = user.first_name.trim();
    usercopy.last_name = user.last_name.trim();
    usercopy.username = user.username != null ? user.username.trim() : null;

    if (typeof user.id !== "undefined" && user.id !== null) {
      delete usercopy.modified_by;
      delete usercopy.created_by;
      delete usercopy.created;
      delete usercopy.modified;
      props.dispatch(
        userActions.editUser({
          id: user.id,
          ...usercopy,
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setSaveUserPending(true);
    } else {
      props.dispatch(
        userActions.registerUser({
          ...usercopy,
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setSaveUserPending(true);
    }
    setItemState("saving");
  };

  const onRegisterSwisspass = (ev) => {
    // example link:
    // https://test-general-frontend.inbooma.net/?hash=74b907031988fdbbba16fc26baaec36eb18c1b332&redirectTo=https://test-web.inbooma.net/users/add#/login-with-swisspass

    // https://test-general-frontend.inbooma.net?hash={CLIENT_ID_HASH_HERE}&redirectTo={WEB_FRONTEND_URL_HERE}#/login-with-swisspass
    var url_base,
      redirection,
      clientHash = generateClientHash(Biscuit.get("user.client_id"));
    var host = getApiHost();

    if (host.indexOf("test") >= 0) {
      // test environment
      url_base = "https://test-general-frontend.inbooma.net";
      redirection = "https://test-web.inbooma.net/users";
    } else if (host.indexOf("staging") >= 0) {
      // staging environment
      url_base = "https://staging-general-frontend.inbooma.net";
      redirection = "https://staging-web.inbooma.net/users";
    } else {
      // this should be live environment
      url_base = "https://general-frontend.inbooma.net";
      redirection = "https://web.inbooma.net/users";
    }
    var win = window.open(
      url_base + "?hash=" + clientHash + "&redirectTo=" + redirection + "#/login-with-swisspass",
      "_blank",
    );
    win.focus();
  };

  const onChangeMembership = (e) => {
    // add selection to array if not already selected
    let clone = { ...user };
    if (!e.target.parentNode.classList.contains("selected")) {
      if (e === null || e.length == 0) {
        clone.memberships = [];
      } else {
        for (let i = 0; i < e.length; i++) {
          let id = null;
          let a = null;
          clone.memberships.map((m) => {
            if (m.membership_type_id === e[i].value) {
              id = m.id;
              a = m.membership_type_id;
            }
          });
          console.log(id);
          if (id === null) {
            clone.memberships.push({
              membership_type_id: e[i].value,
              name: e[i].label,
            });
          }
        }
      }
    }
    console.log(clone);
    setUser(clone);
    /*if (!e.target.parentNode.classList.contains("selected")) {
            user.memberships.push({
                membership_type_id: membershipType.id,
                name: membershipType.name
            });
        };*/
  };

  const onChangeForm = (e) => {
    let clone = {};
    Object.assign(clone, user);

    let formErrorClone = { ...formError };

    if (e.target.name.startsWith("user_addresses.0") && clone.user_addresses.length == 0) {
      // no user address stored yet -> create one
      clone.user_addresses.push({});
    }

    if (e.target.name.startsWith("memberships.0") && clone.memberships.length == 0) {
      // no membership stored yet -> create one
      clone.memberships.push({});
    }
    $("#user_item_input_" + e.target.name).css("border-color", "#e3e3e3");
    switch (e.target.name) {
      case "username":
        clone.username = e.target.value;
        if (typeof formError.username !== "undefined") {
          delete formErrorClone.username;
          setFormError(formErrorClone);
        }
        break;
      case "email":
        clone.email = e.target.value;
        // to-do: check e-mail format
        if (typeof formError.email !== "undefined") {
          delete formErrorClone.email;
          setFormError(formErrorClone);
        }
        break;
      case "employee_number":
        clone.employee_number = e.target.value;
        break;
      case "first_name":
        clone.first_name = e.target.value;
        break;
      case "last_name":
        clone.last_name = e.target.value;
        break;
      case "title":
        clone.title = e.target.value;
        break;
      case "id_card_nbr":
        clone.last_name = e.target.value;
        break;
      case "birthdate":
        clone.title = e.target.value;
        break;
      case "lang":
        clone.lang = e.target.value;
        break;
      case "company":
        clone.company = e.target.value;
        break;
      case "role":
        clone.role = e.target.value;
        break;
      case "active":
        clone.active = e.target.checked;
        break;
      case "newsletter":
        clone.newsletter = e.target.checked;
        break;
      case "free_unit_able":
        clone.free_unit_able = e.target.checked;
        break;
      case "cost_centre":
        clone.cost_centre = e.target.value;
        break;
      case "user_addresses.0.street":
        clone.user_addresses[0].street = e.target.value;
        break;
      case "user_addresses.0.house_number":
        clone.user_addresses[0].house_number = e.target.value;
        break;
      case "user_addresses.0.country":
        clone.user_addresses[0].country = e.target.value;
        break;
      case "user_addresses.0.city":
        clone.user_addresses[0].city = e.target.value;
        break;
      case "user_addresses.0.zip_code":
        clone.user_addresses[0].zip_code = e.target.value;
        break;
      case "user_addresses.0.phone_number":
        clone.user_addresses[0].phone_number = e.target.value;
        break;
      case "user_addresses.0.mobile":
        clone.user_addresses[0].mobile = e.target.value;
        break;
      case "memberships.0.status":
        clone.memberships[0].status = e.target.checked;
        break;
      case "memberships.0.name":
        clone.memberships[0].name = e.target.value;
        break;
      case "memberships.0.external_customer_id":
        clone.memberships[0].external_customer_id = e.target.value;
        break;
      case "memberships.0.subscriptions":
        clone.memberships[0].subscriptions = e.target.value;
        break;
      default:
        clone[e.target.name] = e.target.value;
        break;
    }
    setUser(clone); // set object state
  };

  const _printPostalVerification = (id, user) => {
    getDocHandler(
      "/postalVerification/" + id,
      "GET",
      "application/pdf",
      "Verifizierung der Anschrift - " + user.last_name + " " + user.first_name + ".pdf",
      "",
      id,
      null,
      true,
    );
  };

  const restoreUser = (id) => {
    props.dispatch(
      userActions.restoreDeletedUser({
        id: id,
        method: "GET",
        token: Biscuit.get("token"),
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setSaveUserPending(true);
  };

  const purgeUser = (id) => {
    if (confirm(t("really_hard_remove"))) {
      props.dispatch(
        userActions.purgeUser({
          id: id,
          method: "DELETE",
          token: Biscuit.get("token"),
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setSaveUserPending(true);
    }
  };

  const currentUrl = new URL(window.location.href);
  let paramsUrl = currentUrl.search;
  if (props.requestPath === "/users") {
    paramsUrl = paramsUrl.replace("path=/users&", "");
    paramsUrl = paramsUrl.replace("path=/users", "");
  } else if (props.requestPath === "/users/staff") {
    paramsUrl = paramsUrl.replace("path=/users/staff&", "");
    paramsUrl = paramsUrl.replace("path=/users/staff", "");
  }
  const abortButtonRef = React.createRef();
  let returnUrl =
    typeof props.requestPath !== "undefined" ? props.requestPath + paramsUrl : `/users${paramsUrl}`;
  if (typeof paramsUrl !== "undefined" && paramsUrl.includes("?path=")) {
    returnUrl = paramsUrl.substring(6);
  }

  let hasTaskTeamLead = false;
  let roles = {
    name: "role",
    display_name: t("role"),
  };
  let langs = {
    name: "lang",
    display_name: t("language"),
  };
  const role = Biscuit.get("user.role");
  const rights = {
    user: 0,
    manager: 1,
    "booking-manager": 1,
    "manager-location": 1,
    "garage-staff": 1,
    mediator: 1,
    admin: 2,
  };

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"></div>
      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        data-close-on-click="false"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {user.id !== null
              ? t("edit_${a}", { a: t("user", null, "capital") })
              : t("add_${a}", { a: t("user", null, "capital") })}{" "}
            {user.id !== null && user.deleted !== null && " (" + t("customer_removed") + ")"}
          </h1>
          <div className="off-canvas__actions column">
            {user.id !== null &&
              (Biscuit.get("client.postalVerification") !== "true" ||
                (Biscuit.get("client.postalVerification") === "true" &&
                  user.postal_verified !== null)) &&
              user.deleted === null && (
                <a
                  id="user-add-order-btn"
                  href={"/orders/add?&user_id=" + user.id + "&skipFilter=1"}
                  title={t("add_${a}", { a: t("order") })}
                  className="button medium hollow round secondary"
                >
                  <i className="fi fi-page-add"></i>
                  <span>{t("add_${a}", { a: t("order") })}</span>
                </a>
              )}
            {user.id !== null &&
              Biscuit.get("client.postalVerification") === "true" &&
              user.postal_verified === null &&
              user.deleted === null && (
                <a
                  id="user-add-order-btn"
                  href="#"
                  title={t("get_postal_pdf")}
                  className="button medium hollow round secondary"
                  onClick={() => _printPostalVerification(user.id, user)}
                  disabled={user.deleted !== null ? true : ""}
                >
                  <i className="fi fi-page-add"></i>
                  <span>{t("get_postal_pdf")}</span>
                </a>
              )}
            {user.id !== null && user.deleted !== null && (
              <a href="#" onClick={() => restoreUser(user.id)}>
                <button
                  type="button"
                  id="inb-resourcesform-restore-button"
                  className={
                    "button medium beautify beautify-" +
                    Biscuit.get("user.client_id") +
                    " button-submit round"
                  }
                  title={t("restore user")}
                >
                  <i className="fi fi-refresh"></i>
                  <span>{t("restore user")}</span>
                </button>
              </a>
            )}
            {user.id !== null &&
              user.deleted !== null &&
              rbac.hasPermission("delete") &&
              rights[role] >= rights[user.role] && (
                <a href="#" onClick={() => purgeUser(user.id)}>
                  <button
                    type="button"
                    id="inb-resourcesform-purge-button"
                    className={
                      "button medium beautify beautify-" +
                      Biscuit.get("user.client_id") +
                      " button-submit round"
                    }
                    title={t("purge user")}
                  >
                    <i className="fi fi-trash"></i>
                    <span>{t("purge user")}</span>
                  </button>
                </a>
              )}
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save", null, "capital")}
              onClick={onSubmit}
              disabled={user.deleted === null ? "" : true}
            >
              {itemState != "saving" && (
                <>
                  <i className="fi fi-check"></i>
                  <span>{t("save")}</span>
                </>
              )}
              {itemState == "saving" && (
                <span>
                  <img className="rollingLoader" src="assets/img/rolling_loader.svg" />
                  {t("save")}
                </span>
              )}
            </button>
            <a href={returnUrl}>
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-resourcesform-abort-button"
                className="button hollow secondary right button-abort round"
                title="Fenster schließen"
              >
                <i className="fi fi-x"></i>
              </button>
            </a>
          </div>
        </header>
        {typeof user.id !== "undefined" && user.id != null && (
          <p className="off-canvas__subtitle off-canvas__header-region">
            {typeof user.created !== "undefined" &&
              t("created_at") +
                " " +
                moment(user.created).format("DD.MM.YYYY HH:mm:ss") +
                " " +
                t("edited_by") +
                " " +
                user.created_by_name +
                " | " +
                t("last_modified_at") +
                " " +
                moment(user.modified).format("DD.MM.YYYY HH:mm:ss") +
                " " +
                t("edited_by") +
                " " +
                user.modified_by_name +
                " | " +
                t("kunden_nbr") +
                ": " +
                (typeof user.customer_nbr !== "undefined" && user.customer_nbr != null
                  ? user.customer_nbr
                  : user.id)}
          </p>
        )}
        <form className="off-content row">
          <UserInput
            value={{ name: "username", display_name: t("username") }}
            val={user.username}
            name={"username"}
            getAvailableRoles={props.getAvailableRoles}
            onChangeForm={onChangeForm}
            formError={formError}
            type="matrixField"
          />
          <UserInput
            value={roles}
            name={"role"}
            val={user.role}
            getAvailableRoles={props.getAvailableRoles}
            onChangeForm={onChangeForm}
            formError={formError}
            type="extraField"
          />
          <UserInput
            value={langs}
            val={user.lang}
            name={"lang"}
            getAvailableRoles={props.getAvailableRoles}
            onChangeForm={onChangeForm}
            formError={formError}
            type="extraField"
          />

          <div className="inb-form-group column medium-3 small-12 active">
            {user.id !== null && (
              <>
                <label className="inb-form__controlLabel">
                  {t("user_active", null, "capital")}
                </label>
                <div className="switch tiny inb-form__controllClass">
                  <input
                    id="user_item_input_active"
                    type="checkbox"
                    className="switch-input"
                    name="active"
                    checked={user.active}
                    onChange={onChangeForm}
                  />

                  <label
                    className={"switch-paddle switch-paddle-" + Biscuit.get("user.client_id")}
                    htmlFor="user_item_input_active"
                  >
                    <span className="show-for-sr">Toggle content</span>
                  </label>
                  <br />
                  <span className="help-text">{t("user_active_body")}</span>
                </div>
              </>
            )}
            {user.id === null && (
              <>
                <label className="inb-form__controlLabel">
                  {t("user_active", null, "capital")}
                </label>
                <div className="switch tiny inb-form__controllClass">
                  <input
                    id="user_item_input_active"
                    type="checkbox"
                    className="switch-input"
                    name="active"
                    checked={user.active}
                    disabled={true}
                    style={{ pointerEvents: "none" }}
                  />

                  <label
                    className={"switch-paddle switch-paddle-" + Biscuit.get("user.client_id")}
                    htmlFor="user_item_input_active"
                    style={{ cursor: "not-allowed" }}
                  >
                    <span className="show-for-sr">Toggle content</span>
                  </label>
                  <br />
                  <span className="help-text">{t("user_active_body")}</span>
                </div>
              </>
            )}
          </div>
          <div className="inb-form-group column medium-3 small-6">
            <label className="inb-form__controlLabel">
              {hasPrivacyAccepted && (
                <i className="fi fi-check" style={{ paddingRight: "10px" }}></i>
              )}
              {!hasPrivacyAccepted && <i className="fi fi-x" style={{ paddingRight: "10px" }}></i>}
              {t("privacy")}
            </label>
            <div className="inb-form__controllClass">
              <span className="form-control uneditable-input"></span>
            </div>
          </div>

          <div className="inb-form-group column medium-3 small-6">
            <label className="inb-form__controlLabel">
              {hasTosAccepted && <i className="fi fi-check" style={{ paddingRight: "10px" }}></i>}
              {!hasTosAccepted && <i className="fi fi-x" style={{ paddingRight: "10px" }}></i>}
              {t("tos")}
            </label>
            <div className="inb-form__controllClass">
              <span className="form-control uneditable-input"></span>
            </div>
          </div>
          <div className="inb-form-group column medium-2 small-6 newsletter">
            <label className="inb-form__controlLabel">
              {t("user_has_newsletter", null, "capital")}
            </label>
            <div className="switch tiny inb-form__controllClass">
              <input
                id="user_item_input_newsletter"
                type="checkbox"
                className="switch-input"
                name="newsletter"
                checked={user.newsletter}
                onChange={onChangeForm}
              />
              <label
                className={"switch-paddle switch-paddle-" + Biscuit.get("user.client_id")}
                htmlFor="user_item_input_newsletter"
              >
                <span className="show-for-sr">Toggle content</span>
              </label>
            </div>
          </div>
          {Biscuit.get("client.hasAmountOfContingents") === "true" && (
            <>
              <div
                className="inb-form-group column medium-12 small-12 hasAmountOfContingents"
                style={{ paddingTop: "30px" }}
              >
                <label className="inb-form__controlLabel">
                  {t("user_free_unit_able", null, "capital")}{" "}
                  <i className="fi fi-info" title={t("user_free_unit_able_info")}>
                    {" "}
                  </i>
                </label>
                <div className="switch tiny inb-form__controllClass">
                  <input
                    id="user_item_input_free_unit_able"
                    type="checkbox"
                    className="switch-input"
                    name="free_unit_able"
                    checked={user.free_unit_able}
                    onChange={onChangeForm}
                  />
                  <label
                    className={"switch-paddle switch-paddle-" + Biscuit.get("user.client_id")}
                    htmlFor="user_item_input_free_unit_able"
                  >
                    <span className="show-for-sr">Toggle content</span>
                  </label>
                </div>
              </div>
            </>
          )}
          <div className="inb-form-group column medium-12 small-12" style={{ paddingTop: "12px" }}>
            <hr />
          </div>
          {matrixFields.map((value) => {
            let val = null;
            let name = "";
            if (value.model === "User") {
              val = user[value.name];
              name = value.name;
            } else if (value.model === "UserAddress") {
              val = getUserAddressInfo(value.name);
              name = "user_addresses.0." + value.name;
            }
            if (value.name !== "username" && value.name !== "role" && value.name !== "newsletter") {
              return (
                <>
                  <UserInput
                    name={name}
                    value={value}
                    val={val}
                    getAvailableRoles={props.getAvailableRoles}
                    onChangeForm={onChangeForm}
                    formError={formError}
                    type="matrixField"
                  />
                </>
              );
            }
          })}

          <div className="inb-form-group column medium-12 small-12">
            <hr />
          </div>

          {user.role == "mediator" && (
            <>
              <div className="inb-form-group column medium-2 small-12 contract.fee_percentage">
                <label className="inb-form__controlLabel">
                  {t("provision", null, "capital") + " (%)"}
                </label>
                <div className="inb-form__controllClass">
                  <input
                    id="user_item_input_contract_fee"
                    type="text"
                    className="form-control"
                    name="contract.fee_percentage"
                    autoComplete="false"
                    placeholder=""
                    value={user.fee}
                    onChange={onChangeForm}
                  />
                </div>
              </div>

              <div className="inb-form-group column medium-12 small-12">
                <hr />
              </div>
            </>
          )}
          {user.role == "manager-location" && (
            <LocationsSelect
              user={user}
              language={language}
              setTasksPending={setTasksPending}
              tasksPending={tasksPending}
              dispatch={props.dispatch}
            />
          )}

          {user.client_id === 7 && (
            <>
              <div className="inb-form-group column medium-2 small-12 memberships.0.status">
                <label className="inb-form__controlLabel">
                  {t("membership_active", null, "capital")}
                </label>
                <div className="switch tiny inb-form__controllClass">
                  <input
                    id="user_item_input_membership_status"
                    type="checkbox"
                    className="switch-input"
                    name="memberships.0.status"
                    checked={getUserMembershipInfo("status")}
                    onChange={onChangeForm}
                  />
                  <label
                    className={"switch-paddle switch-paddle-" + Biscuit.get("user.client_id")}
                    htmlFor="user_item_input_membership_status"
                  >
                    <span className="show-for-sr">Toggle content</span>
                  </label>
                </div>
              </div>

              <div className="inb-form-group column medium-4 small-12 memberships.0.name">
                <label className="inb-form__controlLabel">
                  {t("type_of_membership", null, "capital")}
                </label>
                <div className="inb-form__controllClass">
                  <input
                    id="user_item_input_membership_type"
                    type="text"
                    className="form-control"
                    name="memberships.0.name"
                    maxLength="255"
                    autoComplete="false"
                    placeholder=""
                    value={getUserMembershipInfo("name")}
                    onChange={onChangeForm}
                  />
                </div>
              </div>

              <div className="inb-form-group column medium-4 small-12 memberships.0.external_customer_id">
                <label className="inb-form__controlLabel">
                  {t("user_customer_nbr", null, "capital")}
                </label>
                <div className="inb-form__controllClass">
                  <input
                    id="user_item_input_membership_ext_id"
                    type="text"
                    className="form-control"
                    name="memberships.0.external_customer_id"
                    maxLength="255"
                    autoComplete="false"
                    placeholder=""
                    value={getUserMembershipInfo("external_customer_id")}
                    onChange={onChangeForm}
                  />
                </div>
              </div>

              <div className="inb-form-group column medium-2 small-12 memberships.0.subscriptions">
                <label className="inb-form__controlLabel">{t("user_abo", null, "capital")}</label>
                <div className="inb-form__controllClass">
                  <input
                    id="user_item_input_membership_subscription"
                    type="text"
                    className="form-control"
                    name="memberships.0.subscriptions"
                    maxLength="255"
                    autoComplete="false"
                    placeholder=""
                    value={getUserMembershipInfo("subscriptions")}
                    onChange={onChangeForm}
                  />
                </div>
              </div>
              {typeof user.id !== "undefined" && user.id == null && (
                <div className="off-content row float-right">
                  <div className="inb-form-group">
                    <button
                      id="swisspass-registration-btn"
                      className={"small button beautify beautify-" + Biscuit.get("user.client_id")}
                      onClick={onRegisterSwisspass}
                    >
                      {t("user_registration_swisspass")}
                    </button>
                  </div>
                </div>
              )}
            </>
          )}

          {user.client_id !== 7 && (
            <>
              <MembershipsSelect user={user} dispatch={props.dispatch} />
              {typeof user.id !== "undefined" && user.id !== null && (
                <AbonnementsSelect
                  user={user}
                  language={language}
                  dispatch={props.dispatch}
                  setUser={setUser}
                  formError={formError}
                  setFormError={setFormError}
                  _editUser={_editUser}
                  showNotification={props.showNotification}
                />
              )}
            </>
          )}

          <div className="inb-form-group column medium-12 small-12">
            <hr />
          </div>
          <div className="inb-form-group column medium-12 small-12">
            <label className="inb-form__controlLabel">Service</label>
            <div
              className="inb-form__controllClass"
              style={{
                border: "1px solid #eee",
                padding: "0.5em 0.9em 0.7em 0.9em",
                marginLeft: "0.8em",
                marginBottom: "1.0em",
                fontSize: "0.8em",
              }}
            >
              {user.id !== "" &&
                _tasks.success === true &&
                _tasks.data !== "undefined" &&
                _tasks.data.length > 0 && (
                  <>
                    <div
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        marginBottom: "10px",
                        paddingLeft: "4px",
                      }}
                    >
                      <div style={{ width: "28%" }}>{t("task", null, "capital")}</div>
                      <div style={{ width: "28%" }}>{t("assignment", null, "capital")}</div>
                      <div style={{ width: "16%" }}>{t("date", null, "capital")}</div>
                      <div style={{ width: "18%" }}>{t("status", null, "capital")}</div>
                    </div>
                    {_tasks.data.map((task) => {
                      if (task.team_lead === true) hasTaskTeamLead = true;
                      return (
                        <>
                          <div
                            className="inb-c-item inb-c-item--order row"
                            style={{
                              margin: "0 0 5px 0",
                              backgroundColor: "white",
                              border: "1px solid #eee",
                              padding: "5px 2px 5px 4px",
                            }}
                          >
                            <div
                              style={{
                                width: "28%",
                                height: "1.5rem",
                                paddingTop: "4px",
                              }}
                            >
                              {task.name}
                            </div>
                            <div
                              style={{
                                width: "28%",
                                height: "1.5rem",
                                fontWeight: task.team_lead === true ? "bold" : "normal",
                                paddingTop: "4px",
                              }}
                            >
                              {task.user == null
                                ? ""
                                : (task.user.first_name != null ? task.user.first_name + " " : "") +
                                  (task.user.last_name != null ? task.user.last_name : "")}
                            </div>
                            <div
                              style={{
                                width: "16%",
                                height: "1.5rem",
                                paddingTop: "4px",
                              }}
                            >
                              {task.created != null
                                ? moment(task.created).format("DD.MM.YYYY")
                                : ""}
                              <br />
                              {task.end != null ? moment(task.end).format("DD.MM.YYYY") : ""}
                            </div>
                            <div
                              style={{
                                width: "18%",
                                height: "1.5rem",
                                paddingTop: "4px",
                              }}
                            >
                              {task.status == "inprogress" ? t("in_progress") : t(task.status)}
                            </div>
                            {user.deleted === null && (
                              <>
                                <span className="float-right" style={{ width: "9%" }}>
                                  <a
                                    href={"/tasks/" + task.id + "?path=/users/" + user.id}
                                    style={{ float: "right" }}
                                  >
                                    <button
                                      type="button"
                                      className="inb-round-btn hollow round"
                                      disabled={user.deleted === null ? "" : true}
                                    >
                                      <div className="inb-fi-edit"></div>
                                    </button>
                                  </a>
                                </span>
                              </>
                            )}
                          </div>
                        </>
                      );
                    })}
                  </>
                )}
              <div style={{ marginTop: "20px" }}>
                {(typeof _tasks.data === "undefined" || _tasks.data.length == 0) && (
                  <div style={{ display: "inline-block", marginRight: "5%" }}>
                    <i>{t("still_no_service_team", null, "capital")}</i>
                  </div>
                )}
                {user.deleted === null && (
                  <>
                    {" "}
                    <span>
                      <a
                        href={
                          "/tasks/add?path=/users/" +
                          user.id +
                          "&lead=" +
                          (hasTaskTeamLead === true ? "false" : "true") +
                          "&fk_model=Users&fk_id=" +
                          user.id
                        }
                      >
                        <button type="button" className="inb-round-btn hollow round">
                          {" "}
                          <i className="fi fi-plus"> </i>{" "}
                        </button>
                      </a>
                    </span>
                  </>
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ItemView;
